'use client';
import { useRadioController } from '../../../../hooks/form-controllers';
import { useFormContext } from 'react-hook-form';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { CustomerStore } from '../../types';
import { AssociatedDealerSearchResult } from '../associated-dealer-search-result';

interface Props {
  name: string;
  dealerCustomerStores: CustomerStore[];
  disabled: boolean;
}

export const AssociatedDealerSearchResultList = ({
  name,
  dealerCustomerStores,
  disabled
}: Props) => {
  const { control } = useFormContext();
  const { radioFieldset } = useRadioController({ control, name });

  return (
    <CatFieldset {...radioFieldset}>
      {dealerCustomerStores?.map((store, index) => {
        const isFirstValue = index === 0;
        const isLastValue = index === dealerCustomerStores.length - 1;
        return (
          <AssociatedDealerSearchResult
            name={name}
            key={store.customerNumber}
            store={store}
            isFirstValue={isFirstValue}
            isLastValue={isLastValue}
            disabled={disabled}
          />
        );
      })}
    </CatFieldset>
  );
};
